var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadFileV2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    rx: 6,
    fill: ""
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20312 8.20312C8.20312 7.03814 9.14752 6.09375 10.3125 6.09375H17.3621C17.7916 6.09375 18.2039 6.26213 18.5106 6.56276L20.6369 8.64701L21.3573 9.4211C21.6398 9.72471 21.7969 10.124 21.7969 10.5388V21.7969C21.7969 22.9619 20.8525 23.9062 19.6875 23.9062H10.3125C9.14752 23.9062 8.20312 22.9619 8.20312 21.7969V8.20312Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8125 6.32812V9.60938C17.8125 9.99771 18.1273 10.3125 18.5156 10.3125H21.7969",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6562 16.4061L14.5296 14.72C14.797 14.4794 15.203 14.4794 15.4704 14.72L17.3438 16.4061M15 16.6405V19.2186",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadFileV2);
export default __webpack_public_path__ + "static/media/upload-file-v2.b571a3b9e85015eb0858f78b0a9bba92.svg";
export { ForwardRef as ReactComponent };